module.exports = __webpack_public_path__ + "img/green-point.26c7ed80.svg";